<ami-dialog-message [setting]="message"> </ami-dialog-message>

<div class="surface-card p-4 shadow-2 border-round">
  <div class="font-medium text-2xl text-700 mb-3">
    Confirmación de la operación
  </div>
  <div class="text-500 mb-5">
    Revisar la información de la compra, antes de considerar su agregación al
    almacén.
  </div>

  <div class="mt-2 mb-2">
    <p-fieldset legend="Proveedor seleccionado" [toggleable]="false">
      <div class="surface-section">
        <ul class="list-none p-0 m-0">
          <li
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-3 font-medium">Nombre</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ providerSelected['name'] }}
            </div>
          </li>
          <li
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-3 font-medium">RUC</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ providerSelected['ruc'] }}
            </div>
          </li>
        </ul>
      </div>
    </p-fieldset>
  </div>

  <div class="mt-2 mb-2 py-2">
    <p-fieldset legend="Detalles del documento" [toggleable]="false">
      <div class="surface-section">
        <ul class="list-none p-0 m-0">
          <li
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-3 font-medium">Tipo de documento</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ documentDetails['documentType'] }}
            </div>
          </li>
          <li
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-3 font-medium">
              Código de documento
            </div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ documentDetails['documentCode'] }}
            </div>
          </li>
        </ul>
      </div>
    </p-fieldset>
  </div>

  <ami-table-actions
    [settings]="table.settings"
    [data]="table.data"
    [actions]="table.actions"
  ></ami-table-actions>

  <div class="flex flex-row-reverse p-d-flex p-ai-center p-jc-between">
    <p class="text-2xl">En total se han pagado {{ totalMoney }} soles.</p>
  </div>

  <div class="field col-12 md:col-8"></div>

  <div class="justify-content-end flex align-items-stretch flex-wrap">
    <div class="flex align-items-center justify-content-center m-2">
      <button
        (click)="prevPage()"
        pButton
        type="button"
        label="Anterior"
        class="p-button-warning"
        icon="pi pi-angle-left"
        iconPos="left"
      ></button>
    </div>
    <div class="flex align-items-center justify-content-center m-2">
      <button
        pButton
        pRipple
        label="Confirmar operación"
        type="button"
        (click)="confirmOperation()"
      ></button>
    </div>
  </div>
</div>
